import {
  contentStateToExportedCourse,
  mergeNarrationManifests,
  type Course,
  type CourseBlock,
  type ExportedCourse,
  type Lesson,
  type NarrationManifestContribution,
} from '@course-authoring/shared-types';
import type { LessonRuntimeData } from '../api/exportSourceLoader';

export function buildDraftCoursePreview(
  course: Course,
  lessonRuntimeData: readonly LessonRuntimeData[]
): ExportedCourse {
  const lessons: Record<string, Lesson> = {};
  const blocks: Record<string, CourseBlock> = {};
  const narrationContributions: NarrationManifestContribution[] = [];

  for (const { contentState: lessonState, narration } of lessonRuntimeData) {
    const lesson: Lesson = {
      ...lessonState.lessonMeta,
      blockOrder: [...lessonState.blockOrder],
    };

    lessons[lesson.id] = lesson;

    const lessonBlocks: CourseBlock[] = [];
    for (const blockId of lessonState.blockOrder) {
      const block = lessonState.blocks[blockId];
      if (block) {
        blocks[block.id] = block;
        lessonBlocks.push(block);
      }
    }
    narrationContributions.push({ lessons: [lesson], blocks: lessonBlocks, narration });
  }

  const narration = mergeNarrationManifests(narrationContributions);

  const exportedCourse = contentStateToExportedCourse(
    {
      id: course.id,
      numericId: course.numericId,
      title: course.title,
      description: course.description,
      locale: course.locale,
      defaultLocale: course.defaultLocale,
      availableLocales: course.availableLocales,
      completionCertificateEnabled: course.completionCertificateEnabled,
      certificateMessage: course.certificateMessage,
      completedMessage: course.completedMessage,
      timedCourse: course.timedCourse,
      durationMinutes: course.durationMinutes,
      minimumRequiredMinutes: course.minimumRequiredMinutes,
    },
    lessons,
    blocks,
    course.lessonIds
  );
  return {
    ...exportedCourse,
    ...(narration ? { narration } : {}),
  };
}
